import { PdfOptions } from './pdf-options.type';

export const DEFAULT_PDF_OPTIONS: PdfOptions = {
  pageOrientation: 'landscape',
  pageSize: 'A4',
  pageMargins: [20, 20, 20, 60],
  styles: {
    title: {
      margin: [0, 0, 0, 10],
      fontSize: 14,
      bold: true,
    },
    summary: {
      fontSize: 10,
    },
    table: {
      margin: [0, 0, 0, 10],
    },
    footer: {
      fontSize: 8,
      margin: [10, 10, 10, 20],
    },
    footerText: {
      color: '#323232',
    },
  },
};
